import { SET_TRAFFIC_CAMERAS_FROM_SERVER_DATA, RESET_SERVER_TRAFFIC_CAMERA_DATA, DID_VERIFY_SERVER_TRAFFIC_CAMERA_DATA } from '../actions/trafficCameraActions';
import type { SetInitialTrafficCamDataWithServerDataActionType, ServerTrafficCamera, ResetServerTrafficCamDataType, DidVerifyServerTrafficCamDataType } from '../actions/trafficCameraActions';

type InitialLoadTrafficCamerasState = {
    serverTrafficCamerasList?: ReturnType<typeof convertServerTrafficCamData>;
    serverTrafficCamerasGeoJson?: ReturnType<typeof transformTrafficCamerasServerDataToMapGeoJSON>;
    initialLoadLat?: number;
    initialLoadLng?: number;
    didVerifyServerTrafficCameraData: boolean;
}

type InitialTrafficCamsDataActionType = SetInitialTrafficCamDataWithServerDataActionType | ResetServerTrafficCamDataType | DidVerifyServerTrafficCamDataType;
const initialState: InitialLoadTrafficCamerasState = {
    didVerifyServerTrafficCameraData: false
};

export const convertServerTrafficCamData = ( trafficCamsArr: Array<ServerTrafficCamera>, city: string, state: string ) => { // traffic cam data isn't properly formatted to give us city name & state, country, this is a temp fix.
    const modifiedCamsList =  trafficCamsArr?.map( (cam) => {
        return {
            City: city,
            State: state,
            Id: cam.CameraId,
            hsv: false, // streaming was disabled, so let's always set this to false
            Lat: cam.Latitude,
            Lng: cam.Longitude,
            Name: cam.Name,
            Thumbnail: cam.JumboImageUrlCache,
            ThumbnailSmallImageCached: cam.SmallImageUrlCache,
            ThumbnailLargeImageCached: cam.LargeImageUrlCache
        };
    });
    return modifiedCamsList ?? [];
};

const GEOMETRY_TYPE = 'Point';
const FEATURE_TYPE = 'Feature';
const GEOJSON_TYPE = 'FeatureCollection';

export function transformServerCamerasToGeoJSON(camera: ServerTrafficCamera, camNumber = 0 ) {
    const geoJSONResult = {
        geometry: {},
        properties: {},
        type: ''
    };

    const { CameraId: cameraId, Latitude: latitude, Longitude: longitude } = camera;

    const coordinates = [
        longitude,
        latitude
    ];

    const geometry = {
        type: GEOMETRY_TYPE,
        coordinates: coordinates
    };

    const properties = {
        id: cameraId,
        camNumber: `${camNumber + 1}`,
        latitude: latitude,
        longitude: longitude
    };

    geoJSONResult.geometry = geometry;
    geoJSONResult.properties = properties;
    geoJSONResult.type = FEATURE_TYPE;

    return geoJSONResult;
}

export const transformTrafficCamerasServerDataToMapGeoJSON = (cameras: Array<ServerTrafficCamera>) => {
    const camerasFeatures = cameras.map( (camera, index) => transformServerCamerasToGeoJSON(camera, index));
    return  {
        features: camerasFeatures,
        type: GEOJSON_TYPE
    };
};

export function initialServerTrafficCamsData(state: InitialLoadTrafficCamerasState = initialState, action: InitialTrafficCamsDataActionType): InitialLoadTrafficCamerasState {
    switch (action.type) {
        case SET_TRAFFIC_CAMERAS_FROM_SERVER_DATA:
        {
            const { city, state: activeLocationState, serverCameras, lat, lng } = action.payload;
            
            const geoJson = transformTrafficCamerasServerDataToMapGeoJSON(serverCameras);
            const camerasList = convertServerTrafficCamData(serverCameras, city, activeLocationState);
            
            return {
                ...state,
                serverTrafficCamerasList: camerasList,
                serverTrafficCamerasGeoJson: geoJson,
                initialLoadLat: lat,
                initialLoadLng: lng
            };   
        }
        case RESET_SERVER_TRAFFIC_CAMERA_DATA: 
        {
            return {
                ...state,
                serverTrafficCamerasList: undefined,
                serverTrafficCamerasGeoJson: undefined,
                initialLoadLat: undefined,
                initialLoadLng: undefined
            }; 
        }
        case DID_VERIFY_SERVER_TRAFFIC_CAMERA_DATA: 
        {
            return {
                ...state,
                didVerifyServerTrafficCameraData: true
            }; 
        }
        default: {
            return {
                ...state
            };
        }
    }
}